<template>
  <div class="certifiList">
    <div class="disFlex certifiListS" v-if="tableData.rows.length>0">
      <div class="certifiBlockN" v-for="(item,i) in tableData.rows" v-if="item.fraction>=item.passfenshu">
        <div class="certifiBlockN-top" :style="'background-color:'+colors[i]">
          <div class="certifiTitle">{{item.cradname||'河南省职业健康培训合格证书'}}</div>
          <div class="certifiTime">获取时间：{{item.createTime}}</div>
        </div>
        <div class="certifiBlockN-bot disFlex">
          <div class="flex1" @click="showXz(item)">
            <img src="@/assets/images/icons/xiazai.png" />下载
          </div>
          |
          <div class="flex1" @click="showCardInfo(item)">
            <img src="@/assets/images/icons/view.png" />查看
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height: 200px;background-color: #fff;text-align: center;">
      <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
      <div style="font-size: 18px;color: #999999;">暂无证件</div>
    </div>
    <el-dialog title="证书详情" :visible.sync="dialogVisible" width="900px" :destroy-on-close="true">
      <div>
        <!--  style="height: 600px;overflow-y: auto;" -->
        <div id="firefoxA" style="display:none;"></div>
        <div id="allcarddiv">
          <div id="page1">
            <div class="pxcard-title1">
              河南省职业健康培训
            </div>
            <div class="pxcard-title2">
              合格证书
            </div>
            <div class="pxcard-touxiang" v-show="avatarurl">
              <img :src="'/jtzy'+avatarurl" style="width:100px;height:140px;" />
            </div>
            <div class="pxcard-yw">
              <div class="heng"></div>CERTIFICATE<div class="heng"></div>
            </div>
            <div class="pxcard-number">NO.{{activeCard.card}}</div>
            <div class="pxcard-wz">
              <div class="pxcard-ch">
                <span class="pxcard-nr" style="padding: 0 15px;">{{activeCard.REAL_NAME}}</span>先生/女士
              </div>
              <div class="pxcard-cont">
                所属单位：
                <span class="pxcard-nr" v-for="(item,i) in activeCard.entnameArr"
                  :style="i==0?'padding-left:5px;':((i==activeCard.entnameArr.length-1)?'padding-right:5px;':'')">{{item}}</span>
                于{{activeCard.year}}年参加
                <span class="pxcard-nr" v-for="(item,i) in activeCard.pxnameArr"
                  :style="i==0?'padding-left:5px;':((i==activeCard.pxnameArr.length-1)?'padding-right:5px;':'')">{{item}}</span>
                ，培训内容：
                <span class="pxcard-nr" v-for="(item,i) in activeCard.cnameArr"
                  :style="i==0?'padding-left:5px;':((i==activeCard.cnameArr.length-1)?'padding-right:5px;':'')">{{item}}</span>。
              </div>
              <div>
                成绩合格，特发此证!
              </div>
              <div
                :style="(isXz?'bottom: 78px;':'bottom: 80px;')+'text-align: right;line-height: 35px;position: absolute;right: 70px;'">
                <div>河南广通安全评价有限公司</div>
                <div>{{activeCard.time}}</div>
              </div>
              <div
                :style="(isXz?'bottom: 52px;':'bottom: 54px;')+'text-align: right;line-height: 35px;position: absolute;right: 70px;'">
                <img src="/static/images/gtzhang.png" />
              </div>
              <div
                :style="(isXz?'bottom: 58px;':'bottom: 60px;')+'text-align: right;line-height: 35px;position: absolute;left: 100px;width: 100px;text-align: center;'">
                <div id="qrCodeDiv" ref="qrCodeDiv"></div>
                <div>防伪查询</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isXz">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xzBtn">下载</el-button>
      </span>
    </el-dialog>
    <!-- <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
      :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
    </el-pagination> -->
  </div>
</template>

<script>
  import html2canvas from 'html2canvas';
  // 可生成二维码
  import QRCode from 'qrcodejs2';
  import {
    format
  } from '@/assets/js/common.js';
  export default {
    name: 'Certificate',
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      return {
        formInline: {
          creator: '',
          rows: 10,
          page: 1
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        colors: [
          '#00C0D5',
          '#FF6666',
          '#1C95F3',
          '#99CC33',
          '#999933',
          '#FFCC33',
          '#FF9966',
          '#666699',
          '#009999',
          '#FF99CC'
        ],
        dialogVisible: false,
        isXz: false,
        activeCard: {
          entname: '',
          entnameArr: [],
          pxnameArr: [],
          cnameArr: []
        },
        cardKclist: [],
        qrcodeobj: null,
        avatarurl: ''
      }
    },
    methods: {
      getList: function(id) {
        this.$axios.get('/kt/ktQuestionsUser/getlistPage.htm?' + this.$qs.stringify(this.formInline)).then(res => {
          var data = res.data;
          this.tableData = data;
        })
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      showCardInfo: function(row) {
        this.qrcodeobj ? this.qrcodeobj.clear() : ''
        this.$axios.get('/kt/ktCardUser/getMyCard.htm?uid=' + this.currentUser.id + '&productid=' + row.productid)
          .then(
            res => {
              var data = res.data;
              if (data.stat == '1') {
                var obj = data.data[0];
                obj.entnameArr = obj.entname.split('');
                this.isXz = false;
                var pxname = '“ 河南省';
                obj.ontype == 'ZXKT_producttype_2_2' ? pxname += '医学放射类' : pxname += '职业健康';
                obj.product_pxxz == '1' ? pxname += '主要负责人【初次培训】' : '';
                obj.product_pxxz == '2' ? pxname += '主要负责人【继续教育】' : '';
                obj.product_pxxz == '3' ? pxname += '管理人员【初次培训】' : '';
                obj.product_pxxz == '4' ? pxname += '管理人员【继续教育】' : '';
                pxname += '培训 ”'
                obj.pxnameArr = pxname.split('');
                obj.time = format('YYYY年MM月DD日', new Date(row.createTime));
                obj.year = format('YYYY', new Date(row.createTime));
                this.activeCard = {
                  time: row.createTime.substring(0, 10),
                  ...obj
                };
                this.dialogVisible = true
                var $this = this;
                setTimeout(function() {
                  $this.qrcodeobj = new QRCode($this.$refs.qrCodeDiv, {
                    text: 'http://tsgt2023.tsanquan.com/pagehse/webwh/xmgs/detailzyws.html?uid=' + $this
                      .currentUser.id + '&productid=' + row.productid,
                    width: 100,
                    height: 100,
                    iconSrc: "/static/images/zhawlogol.png",
                    iconRadius: 0,
                    iconBorderWidth: 3,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                  });
                }, 1000)
                // return;
                if (obj.ontype == 'ZXKT_producttype_2_2') {
                  this.cardKclist = [{
                    cname: '放射卫生相关法律法规解诶',
                    index: 1,
                    score: '合格'
                  }, {
                    cname: '电离福射基础与放射诊疗安全和防护',
                    index: 2,
                    score: '合格'
                  }, {
                    cname: '医疗机构职业健康与应急管理',
                    index: 3,
                    score: '合格'
                  }, {
                    cname: '放射卫生纠纷防范',
                    index: 4,
                    score: '合格'
                  }]
                } else if (obj.ontype == 'ZXKT_producttype_2_1') {
                  if (obj.product_pxxz == 1 || obj.product_pxxz == 3 || obj.product_pxxz == 4) {
                    this.cardKclist = [{
                      cname: '形势与政策',
                      index: 1,
                      score: '合格'
                    }, {
                      cname: '职业健康基础知识',
                      index: 2,
                      score: '合格'
                    }, {
                      cname: '职业健康管理知识',
                      index: 3,
                      score: '合格'
                    }, {
                      cname: '案例分析',
                      index: 4,
                      score: '合格'
                    }, {
                      cname: '职业健康相关工作',
                      index: 5,
                      score: '合格'
                    }]
                  } else if (obj.product_pxxz == 2) {
                    this.cardKclist = [{
                      cname: '形势与政策',
                      index: 1,
                      score: '合格'
                    }, {
                      cname: '职业健康管理知识',
                      index: 2,
                      score: '合格'
                    }, {
                      cname: '案例分析',
                      index: 3,
                      score: '合格'
                    }, {
                      cname: '职业健康相关工作',
                      index: 4,
                      score: '合格'
                    }]
                  };
                }
                var arrn = this.cardKclist.map((item, i) => {
                  if (i == 0) {
                    return item.cname
                  } else {
                    return '/' + item.cname
                  }
                });
                var cnamestr = arrn.join('').split('');
                this.activeCard.cnameArr = cnamestr;
                this.dialogVisible = true
              } else {
                this.$message.error(data.message);
              }
            })
      },
      showXz: function(row) {
        this.qrcodeobj ? this.qrcodeobj.clear() : '';
        // 如果是2026年的培训    需要先上传照片再进行下载
        var year = Number(row.createTime.substring(0, 4));
        this.isXz = true;
        // 判断是否上传了头像
        if (!this.avatarurl && year >= 2026) {
          this.$message.error('下载证书需先上传个人头像，请前往个人中心上传个人头像！');
          return;
        }

        this.$axios.get('/kt/ktCardUser/getMyCard.htm?uid=' + this.currentUser.id + '&productid=' + row.productid)
          .then(
            res => {
              var data = res.data;
              if (data.stat == '1') {
                var obj = data.data[0];
                obj.entnameArr = obj.entname.split('');
                var pxname = '“ 河南省';
                this.isXz = true;
                obj.ontype == 'ZXKT_producttype_2_2' ? pxname += '医学放射类' : pxname += '职业健康';
                obj.product_pxxz == '1' ? pxname += '主要负责人【初次培训】' : '';
                obj.product_pxxz == '2' ? pxname += '主要负责人【继续教育】' : '';
                obj.product_pxxz == '3' ? pxname += '管理人员【初次培训】' : '';
                obj.product_pxxz == '4' ? pxname += '管理人员【继续教育】' : '';
                pxname += '培训 ”'
                obj.pxnameArr = pxname.split('')
                obj.time = format('YYYY年MM月DD日', new Date(row.createTime));
                obj.year = format('YYYY', new Date(row.createTime));
                this.activeCard = {
                  time: row.createTime.substring(0, 10),
                  ...obj
                };
                this.dialogVisible = true
                var $this = this;
                setTimeout(function() {
                  $this.qrcodeobj = new QRCode($this.$refs.qrCodeDiv, {
                    text: 'http://tsgt2023.tsanquan.com/pagehse/webwh/xmgs/detailzyws.html?uid=' + $this
                      .currentUser.id + '&productid=' + row.productid,
                    width: 100,
                    height: 100,
                    iconSrc: "/static/images/zhawlogol.png",
                    iconRadius: 0,
                    iconBorderWidth: 3,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                  });
                }, 1000)
                // return;
                if (obj.ontype == 'ZXKT_producttype_2_2') {
                  this.cardKclist = [{
                    cname: '放射卫生相关法律法规解诶',
                    index: 1,
                    score: '合格'
                  }, {
                    cname: '电离福射基础与放射诊疗安全和防护',
                    index: 2,
                    score: '合格'
                  }, {
                    cname: '医疗机构职业健康与应急管理',
                    index: 3,
                    score: '合格'
                  }, {
                    cname: '放射卫生纠纷防范',
                    index: 4,
                    score: '合格'
                  }]
                } else if (obj.ontype == 'ZXKT_producttype_2_1') {
                  if (obj.product_pxxz == 1 || obj.product_pxxz == 3 || obj.product_pxxz == 4) {
                    this.cardKclist = [{
                      cname: '形势与政策',
                      index: 1,
                      score: '合格'
                    }, {
                      cname: '职业健康基础知识',
                      index: 2,
                      score: '合格'
                    }, {
                      cname: '职业健康管理知识',
                      index: 3,
                      score: '合格'
                    }, {
                      cname: '案例分析',
                      index: 4,
                      score: '合格'
                    }, {
                      cname: '职业健康相关工作',
                      index: 5,
                      score: '合格'
                    }]
                  } else if (obj.product_pxxz == 2) {
                    this.cardKclist = [{
                      cname: '形势与政策',
                      index: 1,
                      score: '合格'
                    }, {
                      cname: '职业健康管理知识',
                      index: 2,
                      score: '合格'
                    }, {
                      cname: '案例分析',
                      index: 3,
                      score: '合格'
                    }, {
                      cname: '职业健康相关工作',
                      index: 4,
                      score: '合格'
                    }]
                  };
                }
                var arrn = this.cardKclist.map((item, i) => {
                  if (i == 0) {
                    return item.cname
                  } else {
                    return '/' + item.cname
                  }
                });
                var cnamestr = arrn.join('').split('');
                this.activeCard.cnameArr = cnamestr;
                this.dialogVisible = true
              } else {
                this.$message.error(data.message);
              }
            })
      },
      xzBtn: function() {
        html2canvas(document.getElementById('page1')).then(function(canvas) {
          // document.body.appendChild(canvas);
          canvas.id = "mycanvas";
          canvas.toBlob(
            //传入blob对象
            function(blob) {
              //创建一个img标签
              var newImg = document.createElement("img"),
                //以blob对象为基础创建一个url
                url = URL.createObjectURL(blob)

              newImg.onload = function() {
                //加载后销毁
                // URL.revokeObjectURL(url);
                var aEle = document.createElement("a");
                aEle.href = url;

                aEle.download = "img.png";
                document.getElementById('firefoxA').appendChild(aEle);
                aEle.click();
              };

              //img标签属性赋值
              newImg.src = url;
              //添加为子元素
              document.body.appendChild(newImg);
            });
        });
      },
      // 获取人员信息   主要是头像
      getData: function(id) {
        this.$axios.get('/system/user_role/COM_USER_AQKT/load.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.avatarurl = data.data.avatarurl;
          } else {
            this.$message.error(data.message);
          }
        })
      },
    },
    created: function() {
      this.$set(this.formInline, 'creator', this.currentUser.id);
      this.getList();
      // 获取人员的信息  主要是头像
      this.getData(this.currentUser.id);
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          console.log(val)
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .certifiList {
    padding: 20px;
  }

  .stadyBlok {
    height: 118px;
    opacity: 1;
    margin-right: 20px;
    background: #00bc68;
    border-radius: 4px;
  }

  .certifiListS {
    flex-wrap: wrap;
  }

  .certifiBlockN {
    height: 200px;
    width: 266px;
    border-radius: 2px;
    margin-right: 20px;
    margin-bottom: 20px;
    text-align: center;
  }

  .certifiBlockN-top {
    width: 266px;
    height: 160px;
    opacity: 1;
    background-color: #00c0d5;
    background-image: url(../../assets/images/yuanhuan.png);
    border-radius: 2px 2px 0px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
  }

  .certifiTitle {
    opacity: 1;
    font-size: 20px;
    font-weight: 800;
    margin-bottom: 20px;
  }

  .certifiTime {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  .certifiBlockN-bot {
    height: 40px;
    opacity: 1;
    background: #f7f9fa;
    border: 1px solid #e9e9e9;
    line-height: 40px;
    border-top: none;
    font-size: 14px;
    color: #9a9a9a;
    cursor: pointer;
  }

  .certifiBlockN-bot img {
    margin-right: 4px;
  }

  #page1 {
    background: url('/static/images/cardnewbg1.png') 0 0 no-repeat;
    background-size: 100% 100%;
    font-size: 16px;
    width: 859px;
    height: 637px;
    color: #371b17;
    position: relative;
  }

  .pxcard-title1 {
    text-align: center;
    font-size: 16px;
    letter-spacing: 12px;
    padding-top: 127px;
  }

  .pxcard-title2 {
    text-align: center;
    font-size: 50px;
    font-weight: 800;
    letter-spacing: 14px;
  }

  .pxcard-touxiang {
    position: absolute;
    left: 60px;
    top: 85px;
  }

  .pxcard-yw {
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
  }

  .pxcard-yw .heng {
    width: 54px;
    height: 1px;
    background: #9a9a9a;
    margin: 10px;
  }

  .pxcard-number {
    text-align: right;
    letter-spacing: 2px;
    padding-right: 50px;
  }

  .pxcard-wz {
    padding: 0px 50px;
    font-size: 16px;
    letter-spacing: 2px;
    line-height: 35px;
  }

  .pxcard-cont {
    text-indent: 2em;
  }

  .pxcard-nr {
    line-height: 25px;
    display: inline-block;
    border-bottom: 1px solid #9a9a9a;
    text-indent: 0em;
  }

  #allcarddiv .el-table tr {
    background: transparent;
  }

  #allcarddiv .el-table--border,
  .el-table--group {
    background: transparent;
  }

  #allcarddiv .el-table th.el-table__cell {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/Certificate.vue